import React from 'react';
import { Link } from 'react-router-dom';
import brandLogo from '../assets/img/logo.svg';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const personalData = '/documents/personal-data';
  const privacyPolicy = '/documents/privacy-policy';
  const userAgreement = '/documents/user-agreement';
  const refundPolicy = '/documents/refund-policy';
  const publicOffer = '/documents/public-offer';

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="ftop">
        <div>
          <Link className="nav-logo" to="/" aria-label="На главную">
            <img className="brand-logo-img" src={brandLogo} width="146" height="34" alt="Бюро Души" />
          </Link>
        </div>

        <div className="fcol">
          <h4>Навигация</h4>
          <ul>
            <li><Link to="/about">О нас</Link></li>
            <li><Link to="/pricing">Тарифы</Link></li>
            <li><Link to="/my-appointments">Мои записи</Link></li>
            <li><Link to="/blog">Блог</Link></li>
          </ul>
        </div>

        <div className="fcol">
          <h4>Документы</h4>
          <ul>
            <li>
              <Link to={userAgreement}>Пользовательское соглашение</Link>
            </li>
            <li>
              <Link to={privacyPolicy}>Политика конфиденциальности</Link>
            </li>
            <li>
              <Link to={publicOffer}>Публичная оферта</Link>
            </li>
            <li>
              <Link to={personalData}>Согласие на обработку ПД</Link>
            </li>
            <li>
              <Link to={refundPolicy}>Политика возвратов</Link>
            </li>
          </ul>
        </div>

        <div className="fcol">
          <h4>Контакты</h4>
          <ul>
            <li><a href="mailto:support@burosoul.ru">support@burosoul.ru</a></li>
            <li>ИНН: 602716479144</li>
            <li>ОГРНИП: 326600000000411</li>
          </ul>
        </div>
      </div>

      <div className="fbot">
        <div className="fcopy">© {currentYear} Бюро Души. ИП Козырева Валерия Витальевна</div>
      </div>
    </footer>
  );
}
